"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_006 = void 0;
const MIGRATION_006_SQL = `\
-- Migration 006 (server only): admin allowlist fields on omni_users table.

ALTER TABLE omni_users ADD COLUMN role TEXT NOT NULL DEFAULT 'user'
  CHECK (role IN ('admin','user'));
ALTER TABLE omni_users ADD COLUMN status TEXT NOT NULL DEFAULT 'active'
  CHECK (status IN ('active','suspended'));
ALTER TABLE omni_users ADD COLUMN email TEXT;
ALTER TABLE omni_users ADD COLUMN last_login_at BIGINT;
ALTER TABLE omni_users ADD COLUMN added_by_user_id TEXT REFERENCES omni_users(id);

CREATE UNIQUE INDEX IF NOT EXISTS idx_omni_users_email_tenant
  ON omni_users(lower(email), tenant_id)
  WHERE email IS NOT NULL;
`;
exports.MIGRATION_006 = {
    id: '006_admin_fields',
    version: 6,
    name: 'admin allowlist fields',
    side: 'server',
    sql: MIGRATION_006_SQL,
};
//# sourceMappingURL=006_admin_fields.js.map